import { jsx as _jsx } from "react/jsx-runtime";
import { Carousel, CarouselVariant, SliderNavColor, SliderNavVariant, IconSize, SCROLLABLE_LIST_CONTAINER_SELECTOR, } from '@as/cotopaxi';
import { LazyLoadOptions, } from '@as-react/common-types';
import { Box } from '@yonderland/andes-react';
import { MIN_SCREEN_WIDTH_TABLET } from '../../../constants/ScreenWidthConstants';
import { isExtensiveProductTile, isClickAndCollectOnly, isInStoreOnly } from '../../../util/ProductUtil';
import { ProductTileVertical } from '../../product-tile/vertical/ProductTileVertical';
import { PDP_TAB_OVERLAY_CONTENT_ID } from '../product-detail-tabs/ProductDetailTabPopover';
var ExtensiveSlidesCount;
(function (ExtensiveSlidesCount) {
    ExtensiveSlidesCount["MOBILE"] = "auto";
    ExtensiveSlidesCount[ExtensiveSlidesCount["TABLET"] = 2] = "TABLET";
})(ExtensiveSlidesCount || (ExtensiveSlidesCount = {}));
var SlidesCount;
(function (SlidesCount) {
    SlidesCount[SlidesCount["MOBILE"] = 2] = "MOBILE";
    SlidesCount[SlidesCount["TABLET"] = 3] = "TABLET";
})(SlidesCount || (SlidesCount = {}));
var SlidesSpacing;
(function (SlidesSpacing) {
    SlidesSpacing[SlidesSpacing["MOBILE"] = 8] = "MOBILE";
    SlidesSpacing[SlidesSpacing["TABLET"] = 16] = "TABLET";
})(SlidesSpacing || (SlidesSpacing = {}));
export const ProductCareProductCarousel = ({ addToBasket, compareItems, deliveryPromiseExplanations, getDeliveryPromise, onWishListToggle, products, productTileFormat, updateCompareList, }) => {
    const isExtensiveTile = isExtensiveProductTile(productTileFormat);
    const carouselConfig = {
        variant: isExtensiveTile
            ? CarouselVariant.COMPACT_PRODUCT_TILE_EXTENSIVE
            : CarouselVariant.COMPACT_PRODUCT_TILE_NORMAL,
        arrowsConfig: {
            color: SliderNavColor.BASE,
            variant: SliderNavVariant.CIRCLE,
            iconSize: IconSize.MINOR,
        },
        showPagination: false,
        configurationOverrides: {
            preventClicks: true,
            watchOverflow: true,
            shouldSwiperUpdate: true,
            slidesPerView: isExtensiveTile ? ExtensiveSlidesCount.MOBILE : SlidesCount.MOBILE,
            spaceBetween: SlidesSpacing.MOBILE,
            breakpoints: {
                [MIN_SCREEN_WIDTH_TABLET]: {
                    spaceBetween: SlidesSpacing.TABLET,
                    slidesPerView: isExtensiveTile ? ExtensiveSlidesCount.TABLET : SlidesCount.TABLET,
                },
            },
        },
    };
    const slides = products.map(product => (_jsx("div", { children: _jsx(ProductTileVertical, { compact: true, scrollableWrapperSelector: `#${PDP_TAB_OVERLAY_CONTENT_ID} ${SCROLLABLE_LIST_CONTAINER_SELECTOR}`, addToBasket: addToBasket, getDeliveryPromise: getDeliveryPromise, deliveryPromiseExplanations: deliveryPromiseExplanations, onWishListToggle: onWishListToggle, product: product, compareItems: compareItems, format: productTileFormat, showSwatchesOnHover: false, updateCompareList: updateCompareList, shouldLazyLoadImage: LazyLoadOptions.LAZY_LOAD, showProductOutOfStockOverlay: isExtensiveTile, clickAndCollectOnly: isClickAndCollectOnly(product), inStoreOnly: isInStoreOnly(product), dropdownProps: { appendToBody: true }, parentId: "product-care" }) }, `${product.productCode}_${product.colourId}`)));
    return (_jsx(Box, { children: _jsx(Carousel, Object.assign({}, carouselConfig, { children: slides })) }));
};
